export const CompanyStatusEnum = {
    LIVE: "live",
    TEST_PHASE: "test_phase",
}